import * as yup from 'yup';
import { IRelativeCare, RelativeCareSchema } from './IRelativeCare';
import { IRelativeMandate, RelativeMandateSchema } from './IRelativeMandate';

export const SUPERVISOR_RELATIONSHIP_MAX_LENGTH = 100;

export const SupervisorDataSchema = yup.object({
  lastName: yup.string().required(),
  firstName: yup.string().required(),
  relationship: yup.string().notRequired().nullable().max(SUPERVISOR_RELATIONSHIP_MAX_LENGTH),
  street: yup.string().notRequired().nullable(),
  number: yup.string().notRequired().nullable(),
  zipCode: yup.string().notRequired().nullable(),
  city: yup.string().notRequired().nullable(),
  phone: yup.string().notRequired().nullable(),
  mobilePhone: yup.string().notRequired().nullable(),
  email: yup.string().notRequired().nullable(),
  mainContact: yup.boolean().notRequired(),
  supervisor: yup.boolean().notRequired(),
  invoiceCopy: yup.boolean().notRequired(),
  relativeCares: yup.array<IRelativeCare>(RelativeCareSchema).notRequired(),
  relativeMandates: yup.array<IRelativeMandate>(RelativeMandateSchema).notRequired(),
});

export interface ISupervisorData {
  lastName: string;
  firstName: string;
  relationship?: string;
  street?: string;
  number?: string;
  zipCode?: string;
  city?: string;
  phone?: string;
  mobilePhone?: string;
  email?: string;
  mainContact?: boolean;
  supervisor?: boolean;
  invoiceCopy?: boolean;
  relativeCares: IRelativeCare[];
  relativeMandates: IRelativeMandate[];
}

export const CreateSupervisorDataSchema = yup
  .object({
    residentId: yup.string().required(),
  })
  .concat(SupervisorDataSchema);

export interface ICreateSupervisorData extends ISupervisorData {
  residentId: string;
}

export const UpdateSupervisorDataSchema = yup
  .object({
    id: yup.string().required(),
  })
  .concat(SupervisorDataSchema);

export interface IUpdateSupervisorData extends ISupervisorData {
  id: string;
}
